import ActivityLogOfflineForm from './ActivityLogOfflineForm';

export default ActivityLogOfflineForm;
